// extracted by mini-css-extract-plugin
export default {"alert":"dismissable_alert__DZPoK","close":"dismissable_close__fXVBn"};